import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import {
  Box,
  Modal,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import TableRowSkeleton from "../../../components/skeletons/TableRowSkeleton";
import { GetTransactionsResponse } from "../../../models/wallet.model";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "5px",
  overflow: "auto",
  overflowX: {
    xs: "auto",
    sm: "auto",
    md: "auto",
    lg: "hidden",
  },
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EDEFEF",
    color: "#1D4A87",
    fontWeight: "700",
    fontSize: 14,
    textAlign: "center",
    marginBottom: "0.5rem",
    overflowX: "auto",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center !important",
    overflowX: "auto",
  },
}));
const columns = [
  {
    id: 0,
    title: "نوع تراکنش",
  },
  {
    id: 1,
    title: "مبلغ تراکنش (ريال)",
  },
  {
    id: 2,
    title: "زمان تراکنش",
  },
  {
    id: 3,
    title: "توضیحات تراکنش",
  },
];
interface Props {
  transactionList: GetTransactionsResponse[];
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  loading: boolean;
  handleToSaleDetail: Function;
}

const WalletTransactionsModal = ({
  transactionList,
  openModal,
  setOpenModal,
  loading,
  handleToSaleDetail,
}: Props) => {
  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ border: "1px solid #DAE0E4" }}>
            <TableContainer
              component={Paper}
              sx={{
                direction: "rtl",
                padding: "0.5rem",
                maxWidth: { xs: 300, sm: 500, md: "100%", lg: "100%" },
                width: "100%",
              }}
            >
              {!loading ? (
                <Table
                  sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
                  aria-label="customized table"
                >
                  <TableHead sx={{ outline: "1px solid #DAE0E4" }}>
                    <TableRow>
                      <StyledTableCell align="right"></StyledTableCell>
                      {columns.map((column, index) => (
                        <StyledTableCell align="center" key={index}>
                          {column.title}
                        </StyledTableCell>
                      ))}
                      <StyledTableCell align="right">
                        <MoreHorizIcon />
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ outline: "1px solid #DAE0E4" }}>
                    {transactionList?.map((transaction, index) => (
                      <TableRow key={index}>
                        <StyledTableCell align="right">
                          {transaction?.amount > 0 ? (
                            <ArrowUpwardOutlinedIcon
                              sx={{ color: "#01AF43" }}
                            />
                          ) : (
                            <ArrowDownwardOutlinedIcon
                              sx={{ color: "#E6123D" }}
                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {transaction?.typeTitle || "----"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {Math.abs(transaction?.amount)?.toLocaleString(
                            "fa"
                          ) || "----"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {transaction?.transactionDatePersian || "----"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {transaction?.description || "----"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {transaction?.saleKey ? (
                            <ShoppingCartOutlinedIcon
                              onClick={() =>
                                handleToSaleDetail(transaction?.saleKey)
                              }
                            />
                          ) : (
                            <></>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <Box style={{ height: "0.5rem" }}></Box>
                </Table>
              ) : (
                <TableRowSkeleton rowsNum={3} columnsNum={5} />
              )}
            </TableContainer>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default WalletTransactionsModal;
